import { useEffect, useState } from "react";
import EntityEditor from "../components/EntityEditor";
import { adminApi } from "../api";

const FIELDS = [
  { key: "title", label: "Titolo", required: true },
  { key: "slug", label: "Slug", required: true },
  { key: "category", label: "Categoria", placeholder: "Insight, Case study, Trend…" },
  { key: "excerpt", label: "Estratto (1–2 righe)", textarea: true, rows: 2 },
  { key: "cover", label: "Copertina", type: "image" },
  { key: "author", label: "Autore" },
  { key: "date", label: "Data", type: "date", required: true },
  { key: "read_time", label: "Tempo di lettura", placeholder: "5 min" },
  {
    key: "body",
    label: "Corpo articolo",
    textarea: true,
    list: true,
    rows: 10,
  },
  { key: "published", label: "Pubblicato", type: "checkbox" },
];

const INITIAL = {
  slug: "",
  title: "",
  excerpt: "",
  category: "Insight",
  cover: "",
  author: "Redazione Invest Hospitality",
  date: new Date().toISOString().slice(0, 10),
  read_time: "5 min",
  body: [],
  published: true,
};

export default function AdminNews() {
  const [items, setItems] = useState([]);
  const load = () => adminApi.get("/admin/news").then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, []);

  return (
    <EntityEditor
      title="News & Insights"
      subtitle="Articoli, case study e aggiornamenti del blog."
      endpoint="/admin/news"
      fields={FIELDS}
      items={items}
      initial={INITIAL}
      onReload={load}
      imageField="cover"
      renderRow={(item) => (
        <div>
          <div className="font-display text-lg">{item.title}</div>
          <div className="mt-1 text-xs text-white/50 font-mono uppercase tracking-[0.15em]">
            {item.category} · {item.date} · {item.read_time}
            {item.published === false && (
              <span className="ml-3 text-red-400">BOZZA</span>
            )}
          </div>
        </div>
      )}
    />
  );
}
